var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
export var MediaImageWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 160px;\n  height: 280px;\n  margin: 5px;\n  box-shadow: 0px 0px 0px 1px rgba(0, 0, 0, 0.15);\n  border-radius: 12px;\n  overflow: hidden;\n"], ["\n  width: 160px;\n  height: 280px;\n  margin: 5px;\n  box-shadow: 0px 0px 0px 1px rgba(0, 0, 0, 0.15);\n  border-radius: 12px;\n  overflow: hidden;\n"])));
var templateObject_1;
